import { useTranslation } from 'react-i18next';

export function useFormContainer() {
  const { t } = useTranslation();

  const label = t('charity.form.label');

  return { label };
}
